export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              会社概要
            </h2>
            <div className="w-16 h-1 bg-green-600 mx-auto"></div>
          </div>

          <div className="bg-gray-50 border border-gray-300 p-8">
            <table className="w-full" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              <tbody>
                <tr className="border-b border-gray-300">
                  <th className="text-left py-4 px-4 bg-green-50 font-bold text-gray-800 w-1/3">
                    会社名
                  </th>
                  <td className="py-4 px-4 text-gray-700">
                    合同会社Nature
                  </td>
                </tr>
                <tr className="border-b border-gray-300">
                  <th className="text-left py-4 px-4 bg-green-50 font-bold text-gray-800">
                    所在地
                  </th>
                  <td className="py-4 px-4 text-gray-700">
                    〒239-0831<br />
                    神奈川県横須賀市ハイランド三丁目27番24号
                  </td>
                </tr>
                <tr className="border-b border-gray-300">
                  <th className="text-left py-4 px-4 bg-green-50 font-bold text-gray-800">
                    設立
                  </th>
                  <td className="py-4 px-4 text-gray-700">
                    令和6年10月25日
                  </td>
                </tr>
                <tr>
                  <th className="text-left py-4 px-4 bg-green-50 font-bold text-gray-800">
                    事業内容
                  </th>
                  <td className="py-4 px-4 text-gray-700">
                    営業代行業務
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-12 bg-green-50 border-l-4 border-green-700 p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              ごあいさつ
            </h3>
            <p className="text-gray-700 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              合同会社Natureは、お客様のビジネスパートナーとして、営業代行業務を通じて貢献することを使命としております。誠実な対応と確かな実績で、お客様の信頼にお応えし、共に成長していくことを目指しております。どうぞお気軽にご相談ください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}